import Axios from "axios"

export function checkForUtm(query){
    let utm = {}
    if(query.utm_medium){
        utm['utm_medium'] = query['utm_medium']
    }
    if(query.utm_campaign){
        utm['utm_campaign'] = query['utm_campaign']
    }  
    if(query.utm_term){
        utm['utm_term'] = query['utm_term']
    }       
    if(query.utm_content){
        utm['utm_content'] = query['utm_content']
    }     
    if(!_.isEmpty(utm)){
        Axios.post('/utm',utm).catch(err=>{})
    }    
}


// WEBPACK FOOTER //
// ./resources/js/mixins/utmHelper.js